module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/cowork-4-ea79180c04af434dbd0cc3a11b5b0c10.jpg";